import { Injectable, signal } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class SessionService {
  readonly username = signal<string | null>(null);

  constructor(private readonly api: ApiService) {}

  async refresh(): Promise<boolean> {
    try {
      const me = await this.api.me();
      this.username.set(me.username);
      return true;
    } catch {
      this.username.set(null);
      return false;
    }
  }
}
